import React, { useState, useEffect } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const JoyrideTour = ({ steps, run, setRun, onFinish }) => {
  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      if (onFinish) onFinish();
      const mainContent = document.querySelector('.main-base-content');
      if (mainContent) {
        mainContent.scrollTop = 0;
      }
      window.scrollTo(0, 0);
    }

    window.dispatchEvent(new CustomEvent('joyride:step', { detail: data }));
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      disableScrolling={true}
      disableOverlayClose={true}
      spotlightClicks={true}
      callback={handleJoyrideCallback}
      locale={{
        back: 'Voltar',
        close: 'Fechar',
        last: 'Finalizar',
        next: 'Próximo',
        skip: 'Pular',
      }}
      styles={{
        options: {
          primaryColor: '#17497F',
          zIndex: 10000,
        },
      }}
    />
  );
};

export default JoyrideTour;
